<template>
  <div class="currency-list">
    <template v-for="currency in currencies" :key="currency.abbr">
      <div class="currency-item" @click="setCurrency(currency.abbr)">
        <div class="currency-item__img">
          <img class="img" :src="currency.flag_image" :alt="currency.abbr" />
        </div>
        <div class="currency-short">{{ currency.abbr }}</div>
        <div class="currency-name">{{ currency.name }}</div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  const auctionStore = useAuctionStore();
  const currency = computed(() => auctionStore.currency);
  const currencies = computed(() => auctionStore.currencies);

  const setCurrency = (value: string) => {
    const selectedCurrency = currencies.value.find(item => item.abbr === value);
    auctionStore.$patch({
      currency: value,
      isCurrencyBase: selectedCurrency?.is_base
    });
  };
</script>

<style lang="scss" scoped>
  .currency-list {
    font-family: "Montserrat", sans-serif;
    color: #707070;
  }
  .currency-item {
    padding: 10px 16px;
    display: flex;
    align-items: center;
    transition: 0.2s all linear;
    cursor: pointer;

    &:nth-child(odd) {
      background-color: #f9f9f9;
    }

    &:hover {
      background-color: #e6f2ff;
    }
  }
  .currency-short {
    font-size: 18px;
    line-height: 1;
    margin-left: 15px;
  }
  .currency-name {
    font-size: 16px;
    line-height: 1;
    margin-left: auto;
  }
  .currency-item__img {
    width: 28px;
    height: 28px;
  }
  .currency-description {
    display: block;
    margin-bottom: 32px;
  }

  @media (max-width: 1440px) {
    .currency-item__img {
      width: 26px;
      height: 26px;
    }
    .currency-short {
      font-size: 17px;
    }
    .currency-name {
      font-size: 15px;
    }
  }

  @media (max-width: 1280px) {
    .currency-item__img {
      width: 24px;
      height: 24px;
    }
    .currency-short {
      font-size: 16px;
    }
    .currency-name {
      font-size: 14px;
    }
  }
</style>
